import moment from "moment";
import "moment/locale/id";
import { CurrencyFormat } from "../../../components/helpers";

export const convertLoanCampaign = (data, outlet, category) => {
  let convertedLoanCampaign = [];
  console.log(data)

  if (!data) return [];

  data.forEach((item, index) => {
    let startDate = moment(item.start_date).format("DD/MM/YYYY");
    let endDate = moment(item.end_date).format("DD/MM/YYYY");
    convertedLoanCampaign.push({
      item: item,
      key: index + 1,
      paymentType:
        item.payment_type === "balloon_payment"
          ? "Balloon Payment"
          : item.payment_type === "installment"
            ? "Installment"
            : null,
      campaignName: item.name,
      tenorType:
        item?.tenor_type === "reguler"
          ? "Reguler"
          : item.tenor_type === "non_reguler"
            ? "Non-Reguler"
            : null,
      maxExtension: `${item.max_extension} Kali`,
      minLoan:
        item.min_loan_rupiah !== 0
          ? `Rp ${CurrencyFormat(item.min_loan_rupiah)}`
          : `${item.min_loan_percentage} %`,
      maxLoan:
        item.max_loan_rupiah !== 0
          ? `Rp ${CurrencyFormat(item.max_loan_rupiah)}`
          : `${item.max_loan_percentage} %`,
      capitalLoan:
        item.capital_loan_rupiah !== 0
          ? `Rp ${CurrencyFormat(item.capital_loan_rupiah)}`
          : `${item.capital_loan_percentage} %`,
      feeAdminRupiah: `Rp ${CurrencyFormat(item.fee_admin_rupiah)}`,
      feeAdminPercent: `${item.fee_admin_percentage} %`,
      feeSavingInsurance:
        item.fee_saving_assurance_rupiah !== 0
          ? `Rp ${CurrencyFormat(item.fee_saving_assurance_rupiah)}`
          : `${item.fee_saving_assurance_percentage} %`,
      lateCharge:
        item.late_charge_rupiah !== 0
          ? `Rp ${CurrencyFormat(item.late_charge_rupiah)}`
          : `${item.late_charge_percentage} %`,
      feeAuction:
        item.fee_auction_rupiah !== 0
          ? `Rp ${CurrencyFormat(item.fee_auction_rupiah)}`
          : `${item.fee_auction_percentage} %`,
      date: moment().isBetween(moment(item.start_date), moment(item.end_date))
        ? "Aktif"
        : moment().isAfter(moment(item.end_date))
          ? "Kadaluarsa"
          : moment().isBefore(moment(item.start_date))
            ? `${startDate} sampai ${endDate}`
            : null,
      maxLate: `${item.max_late} Hari`,
      category:
        item.promo_loan_products?.length === category
          ? `Semua Kategori Produk`
          : item.promo_loan_products?.map((e, index) =>
            index + 1 === item.promo_loan_products?.length
              ? `${e.product_category.name}`
              : `${e.product_category.name}, `
          ),
      outlet:
        item.promo_loan_outlets?.length === outlet
          ? "Semua Outlet"
          : item.promo_loan_outlets?.map((e, index) =>
            e.outlet_id === 0
              ? "-"
              : index + 1 === item.promo_loan_outlets?.length
                ? `${e.outlet.name}`
                : `${e.outlet.name}, `
          ),
      tenorPerLoan:
        item?.tenor_type === "non_reguler" &&
          item?.promo_loan_tenors[0].days > 120
          ? "120 Hari"
          : `${item?.promo_loan_tenors[0]?.days} Hari`,
      totalTenor: `${item?.promo_loan_tenors[0]?.days} Hari`,
      feeSavingLate:
        item.fee_storage_rupiah !== 0
          ? `Rp ${CurrencyFormat(item.fee_storage_rupiah)}`
          : `${item.fee_storage_percentage} %`,
      lateChargePeriod:
        item.late_charge_period_rupiah !== 0
          ? `Rp ${CurrencyFormat(item.late_charge_period_rupiah)}`
          : `${item.late_charge_period_percentage} %`,
      maxAccumulativeLate:
        item.max_accumulative_late !== 0
          ? `Rp ${CurrencyFormat(item.max_accumulative_late)}`
          : `${item.max_accumulative_late_percentage} %`,
      notificationGroup: item.notification_group_id,
      gracePeriod: `${item?.grace_period} Hari`,
      periode: `${item?.promo_loan_tenors[0].period} Periode`,
      dayPerPeriod: item?.promo_loan_tenors
        .map((per) => `${per.days} Hari`)
        .join(", "),
      feeSaving:
        item.fee_saving_assurance_sharing_saving_rp !== 0
          ? `Rp ${CurrencyFormat(item.fee_saving_assurance_sharing_saving_rp)}`
          : `${item.fee_saving_assurance_sharing_saving} %`,
      feeInsurance:
        item.fee_saving_assurance_sharing_assurance_rp !== 0
          ? `Rp ${CurrencyFormat(item.fee_saving_assurance_sharing_assurance_rp)}`
          : `${item.fee_saving_assurance_sharing_assurance} %`,
      chargeTimeCapitalLoan: item?.capital_loan_type,
      chargeTimeFeeAdmin: item?.fee_admin_type,
      chargeTimeFeeSavingInsurance: item?.fee_saving_assurance_type,
    });
  });
  return convertedLoanCampaign;
};
